<!--中间显示组件-->
<template>
  <v-main>
    <div id="core-view">
      <v-fade-transition mode="out-in">
        <router-view />
      </v-fade-transition>
    </div>
  </v-main>
</template>

<script>
export default {}
</script>

<style>
.v-content {
  padding: 0px;
}
</style>
